import DeleteOutlined from '@ant-design/icons/DeleteOutlined';
import { Typography } from '@mui/material';
import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  margin-top: -10px;
`;

export const CustomizedTypography = styled(Typography)`
  color: #000000;
`;

export const ErrorMessage = styled(Typography)`
  color: #f44336;
`;

export const CustomizedDeleteIcon = styled(DeleteOutlined)`
  color: #fff;
  left: 45%;
  position: absolute;
  top: 45%;
  visibility: hidden;
`;

export const Wrapper = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: relative;

  img {
    border: 2px solid #395fca;
    max-height: 150px;
    max-width: 150px;
  }

  &:hover {
    transition: 0.3s;

    ${CustomizedDeleteIcon} {
      visibility: visible;
    }

    img {
      filter: brightness(0.5);
    }
  }
`;
